import { Link } from "react-router-dom";
import { Gauge, ListChecks } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { StatusPill, lazyPage } from "@vixio/ui";
import "./api";
import { useKpis } from "./widget-data";

export * from "./api";
export { DashboardView } from "./Widgets";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const KpisPage = lazyPage(() => import("./KpisPage"), "KpisPage");
const DashboardsPage = lazyPage(() => import("./DashboardsPage"), "DashboardsPage");
const SharedDashboardPage = lazyPage(() => import("./SharedDashboardPage"), "SharedDashboardPage");

function KpisWidget() {
  const org = useOrg();
  const rows = (useKpis(org.id).data ?? []).filter((k) => k.active && (k.target !== null || k.limit_op)).slice(0, 6);
  if (!rows.length) return <p className="muted">Nenhum indicador com meta ou limite.</p>;
  return (
    <ul className="vx-stack" style={{ gap: 8, margin: 0, padding: 0, listStyle: "none" }}>
      {rows.map((k) => (
        <li key={k.id} className="vx-row vx-row--between" style={{ flexWrap: "nowrap", gap: 12 }}>
          <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><Link to="/gestao/indicadores/registro">{k.label}</Link></span>
          <span className="num" style={{ whiteSpace: "nowrap" }}>{k.value_text}{k.limit_breached ? <> <StatusPill tone="warn">limite</StatusPill></> : null}</span>
        </li>
      ))}
    </ul>
  );
}

export default defineModuleUi({
  key: "analytics",
  title: "Indicadores",
  domain: "governance",
  icon: Gauge,
  menu: [
    { path: "/gestao/indicadores", label: "Indicadores", minRole: "member", icon: Gauge, order: 10, end: true, keywords: "kpi painel dashboard meta métricas semanal mensal relatório" },
    { path: "/gestao/indicadores/registro", label: "Registro de indicadores", minRole: "member", icon: ListChecks, order: 11, keywords: "kpi dono limite ação meta horas" },
  ],
  routes: [
    { path: "/gestao/indicadores", element: <DashboardsPage />, minRole: "member" },
    { path: "/gestao/indicadores/registro", element: <KpisPage />, minRole: "member" },
  ],
  widgets: [{ key: "analytics.kpis", title: "Indicadores do mês", minRole: "member", span: 1, order: 5, element: KpisWidget }],
  publicRoutes: [{ path: "/indicadores/:token", element: <SharedDashboardPage /> }],
});
